export default "__VITE_ASSET__BcYOpVA___"